// DS: MO0.4
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import UserAvatar from '../../../../User/Avatar';
import s from './MonetizationBlock.scss';
export var MonetizationBlock = function (_a) {
    var contentType = _a.block.contentType, deviation = _a.deviation;
    var t = useTranslation().t;
    var type;
    if (contentType === 'monetization_promotion_tier' ||
        contentType === 'subscription_promotion' /* backwards compatibility */) {
        type = 'tier';
    }
    else if (contentType === 'monetization_promotion_commission') {
        type = 'commission';
    }
    else {
        return null;
    }
    var biData = {
        evid: type === 'tier'
            ? BiEventType.VIEW_SUBSCRIPTION_TAB
            : BiEventType.VIEW_COMMISSIONS_TAB,
        typeid: deviation.typeId,
        itemid: deviation.deviationId,
        referral_info: ReferralType.SIDEBAR_PROMOTION,
    };
    if (!deviation.author) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: c(s['content'], s["type-".concat(type)]) },
            React.createElement(UserAvatar, { className: s['avatar'], user: deviation.author, withTooltip: true, size: 48, relatedItemBiData: {
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId,
                } }),
            React.createElement("div", { className: s['text'] }, t("sidebar.monetizationBlock.var.".concat(type, ".body"))),
            React.createElement(BiLink, { className: s['btn-subscribe'], href: type === 'tier'
                    ? Url.userSubscriptionsPath({
                        username: deviation.author.username,
                    })
                    : Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS), biData: biData }, t("sidebar.monetizationBlock.var.".concat(type, ".CTA"))))));
};
MonetizationBlock.displayName = 'MonetizationBlock';
export default MonetizationBlock;
//# sourceMappingURL=MonetizationBlock.js.map